const preventDefault = event => {
  event.preventDefault();
};

export default preventDefault;